import { render, staticRenderFns } from "./MeitiTypeWarning.vue?vue&type=template&id=383c4f6f&"
import script from "./MeitiTypeWarning.vue?vue&type=script&lang=js&"
export * from "./MeitiTypeWarning.vue?vue&type=script&lang=js&"
import style0 from "./MeitiTypeWarning.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports